import { reviews } from "@/mocks/comics";

export default function Reviews() {
  return (
    <section id="reviews" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-9 text-center">
          <span className="text-sm font-bold tracking-wide text-primary-600">READER PRAISE</span>
          <h2 className="mt-2 text-2xl font-black text-foreground-950 md:text-4xl">读者口碑 · 越追越上头</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            来自沙雕追更党的真实评价，反转与脑洞让人笑到停不下来。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {reviews.map((r) => (
            <figure
              key={r.id}
              className="flex flex-col rounded-2xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-accent-300 hover:bg-background-50"
            >
              <div className="flex gap-0.5 text-sm text-accent-500" aria-label="五星好评">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                <img
                  src={r.avatar}
                  alt={`读者${r.name}的头像`}
                  className="h-10 w-10 rounded-full object-cover"
                />
                <div>
                  <div className="text-sm font-bold text-foreground-950">{r.name}</div>
                  <div className="text-xs text-foreground-500">{r.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}